export const PROJECT_GOALS_CONFIG = {
    name            : 'Goals',
    icon            : 'i5-goals',
    // iconLight       : 'i5-goal-light',
    image           : 'goals',
    iconSvg         : 'isvg-goals',
    url             : 'goals',
    stringId        : 'goals',
    description     : 'On the Goals page within the project, you can set and track goals, as well as share progress with the team to achieve success in the project.',
    menuName        : 'Goals',
    inheritance     : false,
    // isSingleton     : true,
}
